<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch02">
<a id="page5">
<div class="chapterHead">
<h2 class="chapterTitle"> </h2>
</div>
</a><div class="chapterBody"><a id="page5">
<p class="chapterOpenerText"><span class="chapterOpenerFirstLetters"><span class="bold"><em class="italic">H</em></span></span>e was surprised at how pretty she was. He hadn’t expected her to be so pretty. He had seen the photograph that ran in <em class="italic">The Journal</em> and others, when he’d gone through her file, but they were grainy and her hair, done in the fashion of the times, even though pinned up, fell a bit about her face obscuring a clear view.</p>
<p class="para">He hadn’t expected her to be so delicate or refined. He had thought the last three years, first when she was incarcerated with her father on the Isle of Pines and then imprisoned on her own in Havana, would have shown more marks on her, visible marks.</p>
</a><p class="para"><a id="page5">He was surprised, also, at her—complacency was the wrong word but there was a dignity about her, unex</a><a id="page6">pected in one so young. She was only nineteen. And yet her spirit, visible in her eyes, in the way that she took everything in in a moment and her agility, evident even though she was seated, indicated something stronger and wild, if pushed. He wondered if he would be able to trust her. Trust was always fairly tricky with someone who believed in a cause more than in anything else. And if he would be able to get her to trust him.</a></p><a id="page6">
<p class="para">Better not to reveal too much, at first. Better to maintain the facade that he was a journalist and had no purpose other than to interview her. Better to let her tell her story in her own words, that would be the best way for him to get a sense of her.</p>
</a></div><a id="page6">
</a></div>
<a id="page6">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// whiterose_ch02.vue?32316762